/**
 * Jotai atoms for lead details drawer state management
 *
 * The drawer state is URL-driven:
 * - URL format: /:servicesProviderId/leads/:tabId/:leadId/:detailsTab
 * - When leadId and detailsTab params are present, drawer is open
 * - When leadId and detailsTab params are absent, drawer is closed
 *
 * Use the `useLeadNavigation` hook for all navigation operations.
 */

import { atom } from 'jotai';

import type { LeadsTableRow } from '@ekhodealer/ekho-common';

export enum LeadDetailsTab {
	OVERVIEW = 'overview',
	CONVERSATIONS = 'conversations',
}

// ============================================================================
// Selected Lead State
// Stores the currently selected lead for tab content components to access
// This is set by the LeadDetailsDrawer based on the URL params
// ============================================================================

export interface LeadDetailsDrawerState {
	selectedRow: LeadsTableRow | null;
}

export const leadDetailsDrawerAtom = atom<LeadDetailsDrawerState>({
	selectedRow: null,
});
